import { connect } from 'react-redux';
import { RootState } from '../api';
import Profile, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../components/Profile';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (
    { users, user, tracks: { userTracks, isFetchingUserTracks } },
    { profileId },
  ) => {
    const tracksForUser = userTracks[profileId];
    return {
      isOnline: users.onlineUsersIds.includes(profileId),
      currentId: user.id,
      role: user.role,
      userHasTracks:
        (!user.isFetchingAllTracks || !isFetchingUserTracks) &&
        tracksForUser &&
        Object.keys(tracksForUser.data).length > 0,
    };
  },
)(Profile);
